module.exports = __webpack_public_path__ + "img/audi.b950b1ef.png";